export default __webpack_public_path__ + "static/media/about.8c7f2eb8.jpg";